import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ModalContextProvider } from "../../context/ModalContext";
import { useEventContext } from "../../context/EventContext";
import PageContainer from "../../components/PageContainer";

import "./style.scss";

export default ({ children }) => {
    const { pages } = useEventContext();
    const params = useParams();

    const page = pages.find(({ type }) => type === 'shop');
    const pageSettings = page?.settings || {};

    useEffect(() => {
        addPageStyles();
    }, [params]);

    function addPageStyles() {
        const quizPage = document.querySelector('.shop-page-root');

        quizPage.style.backgroundImage = `url(${pageSettings.backgroundUrl})`;

        pageSettings.backgroundFixed
            ? quizPage.classList.add('shop-page-root--background-fixed')
            : quizPage.classList.remove('shop-page-root--background-fixed')
    }

    return <PageContainer>
        <ModalContextProvider>
            <section>
                {children}
            </section>
        </ModalContextProvider>
    </PageContainer>
}